import React from "react"
import "./index.scss"

const Tag = (props) => {
  return <span className={`state ${props.className}`}>{props.children}</span>
}

export default Tag
